<template>
  <div class="card">
    <div class="card-body">
      <div class="card">
        <div class="card-body">
          <div class="tab-pane">
            <h4 class="card-title mb-5">Telefones</h4>
            <b-table
              striped
              hover
              responsive="sm"
              :items="telefones"
              :fields="campos"
            > </b-table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-5">Links úteis</h4>
                  <div class="d-flex align-items-start flex-column mb-4">
                    <div class="media p-2" v-for="link in links" :key="link.label" >
                      <div class="media-body">
                        <div>
                          <a :href="link.url" target="_blank">
                            <h5 class="text-ceter fst-italic text-decoration-underline">
                              {{link.label}} 
                              <i class="mdi mdi-link font-size-20"></i>
                            </h5>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </div>
        <div class="col-md-8">
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="tab-pane">
                  <h4 class="card-title mb-">Localização da Sede Unicampo</h4>
                  <p class="text-muted">Av. Carneiro Leão, 65 - 1409-1412 - Zona 01, Maringá - PR, 87014-010</p>
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3661.1192442358297!2d-51.946147584409424!3d-23.420059262275878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ecd729ba368ab3%3A0x2f2fc9f817fb92b9!2sUNICAMPO!5e0!3m2!1spt-BR!2sbr!4v1641242072314!5m2!1spt-BR!2sbr" 
                    width="600" 
                    height="450" 
                    style="border:0;" 
                    allowfullscreen="" 
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  export default {
    data (){
      return {
        campos: [
          {
            key: "area",
            label: "Área",
          },
          {
            key: "nomeContato",
            label: "Nome do Contato",
          },
          {
            key: "telefone",
            label: "Telefone / Whatsapp",
          },
          {
            key: "email",
            label: "E-mail",
          },
        ],
        telefones: [
          {
            area: "Gestão de Frota",
            nomeContato: "Roberto Kanashiro",
            telefone: "(44) 98812-8593",
            email: "roberto.kanashiro@unicampo.coop.br"
          },
          {
            area: "Gestão de Projetos Agroquímicos",
            nomeContato: "Alex Eduardo Zaniboni",
            telefone: "(44) 99121-1273",
            email: "alex.zaniboni@unicampo.coop.br"
          },
          {
            area: "Gestão de Projetos Agroquímicos",
            nomeContato: "Carlos Alberto Guerreiro (Kaká)",
            telefone: "(44) 99121-8997",
            email: "carlos.guerreiro@unicampo.coop.br"
          },
          {
            area: "Gestão de Projetos Agroquímicos",
            nomeContato: "Carlos Renato Moreno Macedo",
            telefone: "(44) 99117-5273",
            email: "carlos.macedo@unicampo.coop.br"
          },
          {
            area: "Gestão de Projetos Agroquímicos",
            nomeContato: "Joao Carlos de Souza",
            telefone: "(44) 99136-8078",
            email: "joao.souza@unicampo.coop.br"
          },
          {
            area: "Relacionamento com o Cooperado",
            nomeContato: "Raul de Albuquerque Goetzinger",
            telefone: "(44) 99152-2166",
            email: "raul.goetzinger@unicampo.coop.br"
          },
          {
            area: "Operações e Estratégias",
            nomeContato: "Rafael Ribeiro de Assis",
            telefone: "(44) 99172-1175",
            email: "rafael.assis@unicampo.coop.br"
          },
          {
            area: "Gerente de Gestão",
            nomeContato: "Renata Vanessa Mantovani Jorge",
            telefone: "(44) 98816-9696",
            email: "renata.jorge@unicampo.coop.br"
          },
          {
            area: "Gerente Geral",
            nomeContato: "Jose Willami da Silva",
            telefone: "(44) 98808-8521",
            email: "willami@unicampo.coop.br"
          },
        ],
        links: [
          {
            label: "ASTEC - Crédito Rural",
            url:"https://creditorural.apepa.com.br/capa.htm"
          },
          {
            label: "CAR - Cadastro Ambiental Rural",
            url:"https://www.car.gov.br/"
          },
          {
            label: "Certidão Negativa de Débitos",
            url:"http://servicos.receita.fazenda.gov.br/Servicos/certidaointernet/PF/Emitir"
          },
          {
            label: "CREA PR",
            url:"https://www.crea-pr.org.br/ws/"
          },
          {
            label: "EMBRAPA",
            url:"https://www.embrapa.br/"
          },
          {
            label: "Incra",
            url:"https://www.gov.br/incra/pt-br"
          },
          {
            label: "OCB",
            url:"https://www.ocb.org.br/"
          },
          {
            label: "OCEPAR",
            url:"https://www.paranacooperativo.coop.br/ppc/"
          },
          {
            label: "Previsão do tempo",
            url:"https://www.climatempo.com.br/"
          },
          {
            label: "SEAB - PR",
            url:"https://www.agricultura.pr.gov.br/"
          },
          {
            label: "Somos Coop",
            url:"https://www.somos.coop.br/"
          },
          {
            label: "Zoneamento Agrícola",
            url:"https://www.gov.br/agricultura/pt-br/assuntos/riscos-seguro/programa-nacional-de-zoneamento-agricola-de-risco-climatico/portarias"
          },
        ],
      }
    }
  }
  </script>